import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { StreamProvider } from './context/StreamContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Dashboard from './components/Dashboard';
import StreamHost from './components/StreamHost';
import StreamViewer from './components/StreamViewer';
import RestreamManager from './components/RestreamManager';
import Settings from './components/Settings';
import Login from './components/Auth/Login';
import AccountSettings from './components/Account/AccountSettings';
import InviteManager from './components/Invitations/InviteManager';
import ProtectedRoute from './components/ProtectedRoute';
import InviteAccept from './components/InviteAccept';

function App() {
  return (
    <AuthProvider>
      <StreamProvider>
        <Router>
          <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Login />} />
              <Route path="/invite/:inviteCode" element={<InviteAccept />} />
              
              {/* Protected routes */}
              <Route path="/*" element={
                <ProtectedRoute>
                  <Navbar />
                  <main className="container mx-auto px-4 py-8">
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/host" element={<StreamHost />} />
                      <Route path="/viewer/:streamId?" element={<StreamViewer />} />
                      <Route path="/restream" element={<RestreamManager />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/account" element={<AccountSettings />} />
                      <Route path="/invitations" element={<InviteManager />} />
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </main>
                </ProtectedRoute>
              } />
            </Routes>
          </div>
        </Router>
      </StreamProvider>
    </AuthProvider>
  );
}

export default App; 